<template>
<div>

    <div class="box partner-box" @click="tilt_modal = true">
        <img src="https://assets.webbank.com/partners/tilt_logo.png" alt="Tilt Logo">
    </div>

<div class="modal" :class="{'is-active': tilt_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div class="has-text-centered">
            <img src="https://assets.webbank.com/partners/tilt_logo.png" alt="Tilt Logo">
          </div>
            <br>
            <p>In partnership with Tilt, WebBank is the issuer and lender of the Tilt credit card.
                For questions about your Tilt account, please call 855-697-3825 or send an email
                to <a href="mailto:help@tiltmoney.com">help@tiltmoney.com</a>. If you are interested in applying for a Tilt card,
                <a href="#" title="Apply at Tilt" @click="$emit('link-click', 'https://apply.tilt.com/credit-card')">click here</a>.</p>
            <br>
            <p><a href="#" title="Tilt Cardholder Agreement" @click="$emit('link-click', 'https://tilt.com/legal/')">Tilt Cardholder Agreement</a></p>
            <br>
            <p><a href="#" title="Tilt Privacy Policy" @click="$emit('link-click', 'https://tilt.com/privacy/')">Tilt Privacy Policy</a></p>
            <br>
            <p><a href="#" title="WebBank Privacy Notice" @click="$emit('link-click', 'https://cdn.tilt.com/legal/WebBank%20Privacy%20Notice.pdf')">WebBank Privacy Notice</a></p>
            <br>
            <br>
            <button class="button is-primary is-light" @click="tilt_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="tilt_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            tilt_modal: false,
        }
    }
}
</script>
